import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Role, RoleCreate, RoleFilter } from '../data/role';

export function createRoleService(client: AxiosInstance) {
  return createCrudService<Role, RoleCreate, RoleFilter>(client, '/Role', 'roleId');
}

export type RoleService = CrudService<Role, RoleCreate, RoleFilter>;
